import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import API_URL from "../../api/API";
import bg from "../../images/registerBg.jpg";
import logo from "../../images/svg/registerLogo.svg";
import arrowR from "../../images/svg/arrow-right.svg";

export default function BusinessRegister() {
  const navigate = useNavigate();
  const [registeredEmail, setRegisteredEmail] = useState("");

  const [businessTypes, setBusinessTypes] = useState([]);
  const [step, setStep] = useState(1);

  const [formData, setFormData] = useState({
    businessName: "",
    businessType: "",
    fullName: "",
    email: "",
    password: "",
    phone: "",
  });

  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [registered, setRegistered] = useState(false); // 👈 Track success state

  // 🔹 Fetch business types on mount
  useEffect(() => {
    const fetchBusinessTypes = async () => {
      try {
        const response = await fetch(API_URL.MASTER_BUSINESS_TYPE);
        const data = await response.json();
        if (data.success) {
          setBusinessTypes(data.data); // ✅ correct
        } else {
          console.error("Failed to fetch business types:", data.message);
        }
      } catch (err) {
        console.error("Error fetching business types:", err);
      }
    };
    fetchBusinessTypes();
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMsg("");
    setLoading(true);

    try {
      const response = await fetch(API_URL.BUSINESS_REGISTER, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      setLoading(false);

      if (data.success) {
        setSuccessMsg(data.message);
        setRegistered(true); // 👈 Switch to success view
        setRegisteredEmail(formData.email); // 👈 Save email here
        setFormData({
          businessName: "",
          businessType: "",
          fullName: "",
          email: "",
          password: "",
          phone: "",
        });
      } else {
        setError(data.message || "Registration failed.");
      }
    } catch (err) {
      setLoading(false);
      setError("Something went wrong. Please try again.");
      console.error(err);
    }
  };

  return (
    <div className="lg:h-screen bg-white">
      {/* <div className="h-full w-full"> */}
      {!registered ? (
        <>
          <div className="flex max-lg:flex-col items-stretch h-full w-full">
            <div className="block h-96 lg:h-full w-full">
              {/* <div> */}
              <img
                src={bg}
                alt="bg"
                className="object-cover object-center h-full w-full"
              />
              {/* </div> */}
            </div>
            <div className="w-full lg:w-1/2 xl:w-[510px] 2xl:w-[600px] 3xl:w-[710px] overflow-auto flex-none flex justify-center px-5 lg:px-10 py-5">
              <div className="w-full lg:max-w-md mx-auto flex flex-col justify-center">
                {/* logo and title */}
                <div className="mb-8">
                  <Link to="/" className="block w-48 mb-10 lg:mb-16">
                    <img src={logo} alt="logo" className="w-full h-full" />
                  </Link>

                  <div className="space-y-2">
                    <h2 className="text-black font-normal text-[32px] leading-snug">
                      {step === 1 ? "Create Account" : "Business Details"}
                    </h2>
                    <p className="text-foreground">
                      Digital waivers. Secure records.
                    </p>
                  </div>
                </div>

                <form onSubmit={step === 2 ? handleSubmit : (e) => e.preventDefault()} className="space-y-4 text-left">
                  
                  {step === 1 && (
                    <>
                      {/* businessName */}
                       <div>
                        <label
                          htmlFor="businessName"
                          className="block mb-1 text-foreground"
                        >
                          Business Name
                        </label>
                        <input
                          type="text"
                          id="businessName"
                          name="businessName"
                          value={formData.businessName}
                          onChange={handleChange}
                          className="w-full rounded-14 bg-[#F7F7F5] outline-none px-4 py-3"
                          required
                        />
                      </div>

                      {/* email */}
                       <div>
                          <label
                            htmlFor="email"
                            className="block mb-1 text-foreground"
                          >
                            Email Address
                          </label>
                          <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className="w-full rounded-14 bg-[#F7F7F5] outline-none px-4 py-3"
                            required
                          />
                        </div>

                      {/* password */}
                      <div>
                        <label
                          htmlFor="password"
                          className="block mb-1 text-foreground"
                        >
                          Password
                        </label>
                        <input
                          type="password"
                          id="password"
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                          className="w-full rounded-14 bg-[#F7F7F5] outline-none px-4 py-3"
                          required
                        />
                      </div>

                      {error && <p className="text-red-500">{error}</p>}

                    </>
                  )}
                  
                  {step === 2 && (
                    <>

                    <button
                      type="button"
                      onClick={() => setStep(1)}
                      className="text-sm text-gray-500 mb-2"
                    >
                      ← Back
                    </button>

                      {/* fullName */}
                      <div>
                        <label
                          htmlFor="fullName"
                          className="block mb-1 text-foreground"
                        >
                          Full Name
                        </label>
                        <input
                          type="text"
                          id="fullName"
                          name="fullName"
                          value={formData.fullName}
                          onChange={handleChange}
                          className="w-full rounded-14 bg-[#F7F7F5] outline-none px-4 py-3"
                          required
                        />
                      </div>

                      {/* businessType */}
                        {/* 🔹 Business Type Dropdown */}
                        <div>
                          <label
                            htmlFor="businessType"
                            className="block mb-1 text-foreground"
                          >
                            Business Type
                          </label>
                          <select
                            id="businessType"
                            name="businessType"
                            value={formData.businessType}
                            onChange={handleChange}
                            className="w-full rounded-14 bg-[#F7F7F5] outline-none text-foreground text-base px-4 py-3"
                            required
                          >
                            <option value="">Select your industry (gym, salon, etc.)</option>
                            {businessTypes.map((type) => (
                              <option
                                key={type._id}
                                value={type._id}
                                className="text-foreground"
                              >
                                {type.name}
                              </option>
                            ))}
                          </select>
                        </div>

                      {/* phone */}
                      <div>
                        <label
                          htmlFor="phone"
                          className="block mb-1 text-foreground"
                        >
                          Phone (optional)
                        </label>
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          className="w-full rounded-14 bg-[#F7F7F5] outline-none px-4 py-3"
                        />
                      </div>
                      
                      {error && <p className="text-red-500">{error}</p>}

                    </>
                  )}
                      
                  
                  {step === 1 ? (
                    <button
                      type="button"
                      onClick={() => {
                        if (!formData.businessName || !formData.email || !formData.password) {
                          setError("Please fill all required fields");
                          return;
                        }
                        setError("");
                        setStep(2);
                      }}
                      className="w-full bg-highlited rounded-full inline-flex justify-center items-center gap-3 text-black font-medium p-3 md:p-4 hover:bg-[#D5AA00] transition"
                    >
                      Continue →
                    </button>
                  ) : (
                    <button
                      type="submit"
                      disabled={loading}
                      className="w-full bg-highlited rounded-full inline-flex justify-center items-center gap-3 text-black font-medium p-3 md:p-4 hover:bg-[#D5AA00] transition"
                    >
                      {loading ? "Registering..." : "Create Business Account"}
                      <img src={arrowR} alt="arrowR" className="w-3 mt-0.5" />
                    </button>
                  )}
                                    

                </form>

                {/* Register link */}
                <div className="py-2 px-2 space-y-4 mt-2">
                  <p className="text-center text-sm text-commonText">
                    Already have your account?{" "}
                    <Link
                      to="/business/login"
                      className="text-black hover:underline transition-all"
                    >
                      Login here
                    </Link>
                  </p>

                  <p className="text-center text-xs">
                    By creating an account, you agree to the DidYouSign <br />
                    <Link
                      to="/terms"
                      className="underline underline-offset-2 hover:text-black transition"
                    >
                      Terms of Service
                    </Link>{" "}
                    and{" "}
                    <Link
                      to="/privacy"
                      className="underline underline-offset-2 hover:text-black transition"
                    >
                      Privacy Policy
                    </Link>
                    .
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        // ✅ Success view
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">
          <div className="w-full max-w-lg bg-white border border-stroked p-5 sm:p-8 rounded-lg shadow-md mx-auto">
            <div className="text-center">
              <div className="pb-3 border-b border-stroked mb-4">
                <h2 className="text-2xl font-bold  text-black">
                  🎉 Registration Successful!
                </h2>
              </div>
              <p className="mb-2">{successMsg}</p>
              <p className="mb-6 text-gray-900">
                Please check your email (<strong className="text-black hover:underline">{registeredEmail}</strong>) for
                a verification link.
              </p>
              <Link
                to="/business/login"
                className="inline-flex justify-center items-center gap-3 w-full bg-highlited rounded-full text-black font-medium p-3 md:p-4 hover:bg-[#D5AA00] transition"
              >
                Go to Login
                <img src={arrowR} alt="arrowR" className="w-3 mt-0.5" />
              </Link>
            </div>
          </div>
        </div>
      )}
      {/* </div> */}
    </div>
  );
}
